// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"b5bb2c84","1157":"5afe097f","1831":"b97bb3c8","2720":"8e57f570","3975":"8effa155"}[chunkId] + ".chunk.css";
};